/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { MdMusicNote, MdImage, MdVideoLibrary, MdReportProblem } from 'react-icons/md';
import { Switch, Redirect, NavLink } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute.jsx';

import Spinner from '../Spinner';

import MetadataTable from './MetadataTable';
import AssetScenes from './AssetScenes';
import AssetLocations from './AssetLocations';
import AssetVisualPreview from './AssetVisualPreview';
import AssetRelated from './AssetRelated';

import AssetAudioPlayerComponent from './AssetAudioPlayer';
import ReplaceArtworkComponent from './ReplaceArtwork';
import ReplaceMetadataComponent from './ReplaceMetadata';
import AssetMediaSegments from './AssetMediaSegments';

// TODO generalize
const TypeToIcon = (type) => {
    switch (type) {
        case 'video':
            // TODO change to single video
            return <MdVideoLibrary />;
        case 'audio':
            return <MdMusicNote />;
        case 'still':
            return <MdImage />;
        default:
            return <MdReportProblem />;
    }
};

const externalRefs = (refs) =>
    refs.map((r) => (
        <React.Fragment>
            <code key={r.dmrn}>{r.dmrn}</code>
            <br />
        </React.Fragment>
    ));

@inject('assets')
@observer
class AssetDetails extends Component {
    componentDidMount = () => {
        const { match } = this.props;
        this.fetchData(match.params.id);
        // TODO sync asset updates
        // this.assetsStore.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        const { match } = this.props;
        if (nextProps.match.params.id !== match.params.id) {
            // Id changes
            this.fetchData(nextProps.match.params.id);
        }
    };

    componentWillUnmount = () => {
        // this.assetsStore.unsyncUpdates();
    };

    fetchData = (id) => {
        const { assets } = this.props;
        assets.fetchAsset(id);
        // TODO Make dependent on known type before fetch
        assets.fetchRelated(id);
    };

    render() {
        const { assets } = this.props;
        const { asset, related } = assets;
        const { match } = this.props;
        if (!asset || !asset.id) {
            return <Spinner />;
        }
        console.log('Rendering AssetDetails;');
        // <Route render={() => <Redirect to={`${match.url}/metadata`} />} />
        return (
            <div className="row mt-3">
                <div className="col">
                    <h1>
                        {TypeToIcon(asset.type)} {asset.name}
                    </h1>
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to={`${match.url}${match.url.endsWith('/') ? '' : '/details/'}`}
                            >
                                Metadata
                            </NavLink>
                        </li>
                        {asset.type === 'audio' ? (
                            <li className="nav-item">
                                <NavLink
                                    className="nav-link"
                                    to={`${match.url}${
                                        match.url.endsWith('/') ? '' : '/'
                                    }audioplayer/`}
                                >
                                    Audio Player
                                </NavLink>
                            </li>
                        ) : null}
                        {asset.type === 'audio' ? (
                            <li className="nav-item">
                                <NavLink
                                    className="nav-link"
                                    to={`${match.url}${
                                        match.url.endsWith('/') ? '' : '/'
                                    }replacemetadata/`}
                                >
                                    Replace Metadata
                                </NavLink>
                            </li>
                        ) : null}
                        {asset.type === 'audio' ? (
                            <li className="nav-item">
                                <NavLink
                                    className="nav-link"
                                    to={`${match.url}${
                                        match.url.endsWith('/') ? '' : '/'
                                    }replaceartwork/`}
                                >
                                    Replace Artwork
                                </NavLink>
                            </li>
                        ) : null}
                    </ul>
                    <div className="tab-content" id="assetDetails">
                        <Switch>
                            <PrivateRoute
                                exact
                                path={`${match.path}`}
                                component={() => (
                                    <div>
                                        <div className="row mt-3">
                                            <div className="col-8">
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-striped">
                                                        <tbody>
                                                            <tr>
                                                                <th>
                                                                    <FormattedMessage
                                                                        id="Assets.Type"
                                                                        defaultMessage="Type"
                                                                    />
                                                                </th>
                                                                <td>{asset.type}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    <FormattedMessage
                                                                        id="Assets.Name"
                                                                        defaultMessage="Name"
                                                                    />
                                                                </th>
                                                                <td>{asset.name}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    <FormattedMessage
                                                                        id="Assets.MimeType"
                                                                        defaultMessage="MimeType"
                                                                    />
                                                                </th>
                                                                <td>{asset.mimeType}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    <FormattedMessage
                                                                        id="Assets.Tags"
                                                                        defaultMessage="Tags"
                                                                    />
                                                                </th>
                                                                <td>{asset.tags}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    <FormattedMessage
                                                                        id="Assets.ExternalReferences"
                                                                        defaultMessage="External References"
                                                                    />
                                                                </th>
                                                                <td>
                                                                    {externalRefs(
                                                                        asset.externalReferences,
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <h4>Metadata</h4>
                                                    <MetadataTable
                                                        metadata={asset.sortedMetadata}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <AssetVisualPreview
                                                    asset={asset}
                                                    previewStill
                                                    previewAudio
                                                    width={600}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <AssetMediaSegments asset={asset} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <AssetLocations asset={asset} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <AssetRelated
                                                    related={related}
                                                    columns={assets.relatedColumnsConfig}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />
                            <PrivateRoute
                                path={`${match.path}audioplayer/`}
                                component={AssetAudioPlayerComponent}
                            />
                            <PrivateRoute
                                path={`${match.path}replacemetadata/`}
                                component={ReplaceMetadataComponent}
                            />
                            <PrivateRoute
                                path={`${match.path}replaceartwork/`}
                                component={ReplaceArtworkComponent}
                            />

                            <Redirect to={`${match.path}`} />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}

AssetDetails.wrappedComponent.propTypes = {
    // auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    asset: PropTypes.object,
    related: PropTypes.object,
};

export default injectIntl(AssetDetails);
